import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeaturedElementPipe } from './featured-element.pipe';


@NgModule({
  declarations: [
    FeaturedElementPipe,
  ],
  exports: [
    FeaturedElementPipe,
  ],
  imports: [
    CommonModule,
  ],
})
export class FeaturedElementModule { }
